import { Badge, Tabs, Tab, withStyles, WithStyles, Theme, Box } from '@material-ui/core'
import i18next from 'i18next'
//import { FC } from 'react'

const styles = ({ breakpoints, spacing }: Theme) => ({
  container: {
    'box-sizing': 'border-box',
    width: '100%',
    padding: '0.3rem',
    background: '#F3F4F6',
    borderRadius: '7px',
    marginTop: '16px'
  },
  selected: {
    background: '#ffffff !important',
    borderRadius: '7px',
    border: '1px solid #C3C6D1',
    color: '#49CC5B !important',
    margin: '0px',
    padding: '0px',
    height: '40px !important',
    'box-sizing': 'border-box'
  },
  tab: {
    height: '40px !important',
    margin: '0px',
    padding: '0px'
  },
  badge: {
    transform: 'translate(15px, -6px)',
    // '@media (max-width:960px)': {
    //   transform: 'translate(15px, -7px)',
    // },
    '@media (max-width:379px)': {
      transform: 'translate(12px, -7px)',
    },
    '@media (max-width:350px)': {
      transform: 'translate(11px, -7px)',
    },
    '& .MuiBadge-dot': {
      backgroundColor: 'rgb(73, 204, 91) !important',
    },
    '& .MuiBadge-colorPrimary': {
      backgroundColor: 'rgb(73, 204, 91) !important',
      color: '#fff !important',
    },
  }
})

interface ApplicationsTabsProps extends WithStyles {
  currentTab: 'received' | 'rejected' | 'accepted' | 'showingReserved'
  setCurrentTab: React.Dispatch<
    React.SetStateAction<
      'received' | 'rejected' | 'accepted' | 'showingReserved'
    >
  >
  t: i18next.TFunction
  isAdmin: boolean,
  applicationsByStatus: any
}

const ApplicationsTabs = ({
  setCurrentTab,
  currentTab,
  t,
  classes,
  isAdmin,
  applicationsByStatus
}: ApplicationsTabsProps) => (
  <div className={classes.container}>
    <Tabs
      value={currentTab}
      indicatorColor='primary'
      textColor='primary'
      onChange={(event, value) => setCurrentTab(value)}
      aria-label='received and rejected tabs'
      variant='fullWidth'
    >
      <Tab
        label={
          <Box position="relative">
            {t("applications.tabs.received")}
            <Badge
              showZero
              badgeContent={applicationsByStatus.created.length + applicationsByStatus.noAvailableTimes.length}
              color="primary"
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              className={classes.badge}
            />
          </Box>
        }
        value='received'
        className={currentTab === 'received' ? classes.selected : classes.tab}
      />
      {isAdmin && (
        <Tab
          label={
            <Box position="relative">
              {t("applications.tabs.rejected")}
              <Badge
                showZero
                badgeContent={applicationsByStatus.rejected.length}
                color="primary"
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                className={classes.badge}
              />
            </Box>
          }
          value='rejected'
          className={currentTab === 'rejected' ? classes.selected : classes.tab}
        />
      )}
      <Tab
        label={
          <Box position="relative">
            {t("applications.tabs.accepted")}
            <Badge
              showZero
              badgeContent={applicationsByStatus.accepted.length}
              color="primary"
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              className={classes.badge}
            />
          </Box>
        }
        value='accepted'
        className={currentTab === 'accepted' ? classes.selected : classes.tab}
      />
      <Tab
        label={
          <Box position="relative">
            {t("applications.tabs.confirmed")}
            <Badge
              showZero
              badgeContent={applicationsByStatus.showingReserved.length}
              color="primary"
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              className={classes.badge}
            />
          </Box>
        }
        value='showingReserved'
        className={
          currentTab === 'showingReserved' ? classes.selected : classes.tab
        }
      />
    </Tabs>
  </div>
)

export default withStyles(styles)(ApplicationsTabs)
